import React from 'react';

import '../../eingabe/Eingabe.css';
import EingabeKulissentyp from "../../eingabe/EingabeKulissentyp";
import EingabeKulissenbreite from "../../eingabe/EingabeKulissenbreite";
import AusgabeKulissenwerte from "../ausgabeKulissenwerte/AusgabeKulissenwerte";
import EingabeZusatzoptionen from "../../eingabe/EingabeZusatzoptionen";
import {FormattedMessage} from "react-intl";

class EingabeKulissenwerte extends React.Component {
       constructor(props) {
    super(props);
    this.state = {
        kulissenlaenge: 1000,
        kulissenhoehe: 1000,
        selectedKulissenbreite :100,
        selectedKulissentyp : 'HKS',
        optionen: [
            {id: 1, value:<FormattedMessage id="Kulissen_in_Folie" />, isChecked: false},
            {id: 2, value:<FormattedMessage id="Fuehrungsschienen_im_Kanal" />, isChecked: false},
            {id: 3, value:<FormattedMessage id="Anstroemkalotten_einseitig_V_Form" />, isChecked: false},
        ],

        rabatt:0,

        //kulissenanzahl : 1,
    };
    this.handleInputChange= this.handleInputChange.bind(this);
    this.getSelectedKulissentypHandler = this.getSelectedKulissentypHandler.bind(this);
    this.getSelectedKulissenbreiteHandler = this.getSelectedKulissenbreiteHandler.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  getSelectedKulissenbreiteHandler(data) {

       this.setState((state) => {
           return {selectedKulissenbreite: data}
       });
  }

  getSelectedKulissentypHandler(data) {

       this.setState((state) => {
           return {selectedKulissentyp: data}
       });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.name === 'isGoing' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value    });
  }
  onKeyUp(event) {
      if (event.key === "Enter") {
          this.handleInputChange(event);
      }
  }

  // handleCheckChieldElement = (event) => {
  //       let optionen = this.state.optionen;
  //       console.log("Option ID Change: " + event.target.value);
  //         // Wenn Kulissen in Folie nur HKL Kulissen
  //         if(event.target.value == "Kulissen in Folie"){
  //             console.log("Option ID Change: " + event.target.value);
  //             this.getSelectedKulissentypHandler('HKL');
  //         }
  //       optionen.forEach(optionen => {
  //           if (optionen.id == event.target.id) {
  //               optionen.isChecked = event.target.checked;
  //           }
  //       })
  //       this.setState({optionen: optionen})
  // }
  handleCheckChieldElement = (event) => {
        let optionen = this.state.optionen
        // console.log("Option ID Change: " + event.target.value);
        // console.log("Option ID Change: " + event.target.id);
        // if(event.target.value == "Kulissen in Folie"){
        //     console.log("Option ID Change: " + event.target.value);
        //     this.getSelectedKulissentypHandler('HKL');
        // }
        // Kulissen in Folie = HKL
        if(Number(event.target.id) === 1){
            // console.log("Option ID Change: " + event.target.value);
            this.getSelectedKulissentypHandler('HKL');
        }
        // optionen[0].isChecked = event.target.checked;

        optionen.forEach(option => {
            // console.log("Optionen: " + option.id+ " " + event.target.id);
            // console.log("Optionen-target-id: "+ event.target.id);
            if (option.id === Number(event.target.id)) {
                // console.log("Optionen: " + event.target.value + " geändert");
                option.isChecked = event.target.checked;
            }
        })
        this.setState({optionen: optionen})
  }

  render() {
    return(
        <>
            <div className={"form-style-8"}>
                <h2><FormattedMessage id="Eingabe_Kulissen" /></h2>
                <form>
                    <EingabeKulissentyp value={this.state.selectedKulissentyp}  SelectedKulissentyp={this.getSelectedKulissentypHandler} disabledChecked={this.state.optionen[0].isChecked}/>
                    <EingabeKulissenbreite value={this.state.selectedKulissenbreite}  SelectedKulissenbreite={this.getSelectedKulissenbreiteHandler} defaultValue={100}/>
                    <div>
                          <label htmlFor="kulissenhoehe"><FormattedMessage id="Kulissenhoehe" />[mm]{this.state.kulissenlaenge > 4000 ? " max. 4000mm" : this.state.kulissenhoehe <200 ? " min. 200mm" : ""}</label>
                          <input type="number" id='kulissenhoehe' min="200" max="4000" name='kulissenhoehe' defaultValue={1000}
                                 onBlur={this.handleInputChange}
                                 onKeyUp={this.onKeyUp}
                                 required/>
                    </div>

                    <div>
                          <label htmlFor="kulissenlaenge"><FormattedMessage id="Kulissenlaenge" /> [mm]{this.state.kulissenlaenge > 4000 ? " max. 4000mm" : this.state.kulissenlaenge <200 ? " min. 200mm" : ""}</label>
                          <input type="number" id='kulissenlaenge' min="200" max="4000" name='kulissenlaenge' defaultValue={1000}
                                 onBlur={this.handleInputChange}
                                 onKeyUp={this.onKeyUp}
                                 required/>
                    </div>
                        <label><FormattedMessage id="Zusatzoptionen" />: </label>
                        {
                            this.state.optionen.map((optionen) => {
                                return (<EingabeZusatzoptionen handleCheckChieldElement={this.handleCheckChieldElement} key={optionen.id}  id={optionen.id} checked={optionen.isChecked} value={optionen.value} />)
                            })
                        }


                    <div>
                        <label htmlFor="rabatt"><FormattedMessage id="Rabatt" /> [%]</label>
                        <input type="number" id='rabatt' min="0.0" max="100.0" name='rabatt' defaultValue={0}
                               onBlur={this.handleInputChange}
                               onKeyUp={this.onKeyUp}
                               required/>
                    </div>
                </form>

            </div>
            <AusgabeKulissenwerte
                Kulissenbreite={this.state.selectedKulissenbreite}
                Kulissenlaenge={this.state.kulissenlaenge}
                Kulissenhoehe={this.state.kulissenhoehe}
                Kulissentyp={this.state.selectedKulissentyp}
                Rabatt={this.state.rabatt}
                Optionen={this.state.optionen}
            />
        </>
    )

  }
}
export default EingabeKulissenwerte;
